/**
 * Displays a deprecation warning
 *
 * @param message
 */
const deprecated = (message) => {

  // Don't display deprecation warnings in production

  if ('production' === process.env.NODE_ENV) {

    return;

  }

  console.warn(`Deprecation warning: ${message}`);

};

export default deprecated;


// WEBPACK FOOTER //
// ./src/utils/deprecated.js